export function postNavArea() {
  if (document.getElementById('pagination')) {
    const navButtonArea = document.getElementById('pagination');
    const elementCount = navButtonArea.childElementCount;
    console.log(navButtonArea);
    if (elementCount >= 2) {
      navButtonArea.classList.add('is-button__grid');
    } else {
    }
  } else {
  }
}
